"use client";

import Link from "next/link";

interface NavigationProps {
  prevHref?: string;
  nextHref?: string;
  prevLabel?: string;
  nextLabel?: string;
}

export default function NextAndPreviousPageNavigation({
  prevHref,
  nextHref,
  prevLabel = "Previous",
  nextLabel = "Next",
}: NavigationProps): React.JSX.Element | null {
  if (!prevHref && !nextHref) {
    return null;
  }

  return (
    <nav aria-label="Page navigation">
      <ul className="next-and-previous-page-in-section-navigation">
        {prevHref && (
          <li className="previous">
            <Link href={prevHref} rel="prev">
              {prevLabel}
            </Link>
          </li>
        )}
        {nextHref && (
          <li className="next">
            <Link href={nextHref} rel="next">
              {nextLabel}
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
}
